export const mixin = {
  data () {
    return {
      // 客户端传来的等级数据
      // hostessGrade: this.$route.query.hostessGrade || 2,
      // 背景图list
      levelBgList: {
        1: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg0.png'),
        2: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg13.png'),
        3: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg46.png'),
        4: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level_bg710.png'),
      },
      // 徽章背景图list
      levelBadgeList: {
        1: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level0.png'),
        2: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level13.png'),
        3: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level46.png'),
        4: require('@/assets/packageAssets/views/P1_Girls/HostessCenter/default/level710.png'),
      },
    }
  },
}
